import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import introagp from './images/introagp.jpg';
import introday from './images/introdaily.jpg';
import introdaypenuser from './images/introdaypenuser.jpg';
// import introinsulin from './images/introinsulin.jpg';

function HelpIntro() {
  return (
    <main id="instructions" className="textPage">
      <h1>Ohjeet - Sensotrend Dashboard</h1>
      <ul className="toc">
        <li><Link to="/help">Etusivulle</Link></li>
        <br />         
        <li><big><b>Palvelun esittely</b></big></li> 
        <li><Link to="/helpGuidance">Käyttöohjeet</Link></li>
        <li><Link to="/helpTips">Tiedon hyödyntäminen</Link></li>
        <br /> 
        <li><Link to="/helpForPractitioner">Ammattilaisille</Link></li>
      </ul>
      <h1 id="helpIntro">Palvelun esittely</h1>
      <small>Lukuaika noin 4 min.</small>
      <p>
        Sensotrend Dashboard kokoaa yhteen tiedot verensokerista sekä siihen vaikuttavista 
        tekijöistä kuten insuliiniannostelusta, liikunnasta ja ravinnosta.
      </p>
      <ul className="toc">
        <li><Link to="#agp">AGP-raportti</Link></li>
        {/*
        <li><Link to="#insulin">Insuliini</Link></li>
        <li><Link to="#nutrition">Ravinto</Link></li>
        <li><Link to="#exercise">Liikunta</Link></li>
        <li><Link to="#diary">Päiväkirja</Link></li>
        */}
        <li><Link to="#day">Päivänäkymä</Link></li>
        <li><Link to="#penuser">Insuliinikynän käyttäjälle</Link></li>
      </ul>
      <section id="agp">
        <h2>AGP-raportti</h2>
        <p>
          <Link to="#helpIntro">Takaisin alkuun</Link>
        </p>
        <p>
          Sensotrend Dashboardin aloitusnäkymällä on AGP-raportti, joka koostuu neljästä osasta
        </p>
        <p>
          <ol>
            <li>
              <b>Tilastot ja tavoitearvot:</b> Mittaustuloksista laskettuja arvoja ja
              kansainvälisen suosituksen mukaiset glukoosiarvojen tavoitteet.
            </li>
            <li>
              <b>Aika glukoosialueilla:</b> Aika tavoitearvojen mukaisilla glukoosialueilla. Tässä
              kannattaa kiinnittää huomiota siihen, toteutuvatko edellisen kohdan tavoitteet.
            </li>
            <li>
              <b>AGP-kuvaaja:</b> Yhteenveto raportointijaksolta. Kuvaajalta näkee mm., onko
              korkeita tai matalia glukoosiarvoja erityisen paljon tiettynä vuorokaudenaikana.
            </li>
            <li>
              <b>Päivittäiset glukoosiprofiilit:</b> Profiilikuvaa klikkaamalla näytölle avautuu
              päivänäkymä, jolla kyseisen vuorokauden tapahtumat on esitetty yksityiskohtaisemmin.
            </li>
          </ol>
        </p>
        <p>
          AGP-raportin normaali tarkastelujakso on 14 päivää. Tarkastelujaksosta toiseen pystyy
          siirtymään “Päivittäiset glukoosiprofiilit” -otsikon (4) päivämääristä tai nuolinäppäimillä.
          Tarkastelujaksosta voi myös poistaa tietyt päivät klikkaamalla päivittäisten glukoosiprofiilien
          viikonpäivää tai päivämäärää.
        </p>
        <p>
          <img src={introagp} alt="AGP-näkymä" />
        </p>
      </section>
      {/*
      <section id="insulin">
        <h2>Insuliini</h2>
        <p>
          <Link to="#helpIntro">Takaisin alkuun</Link>
        </p>
        <p>
          Insuliininäkymä havinnollistaa insuliinin jakautumista vuorokauden aikana. Tarkastelujakso
          on sama kuin AGP-raportissa.
            </p>
        <p>
          <ol>
            <li>
              <b>Insuniinin käytön tilastot:</b> Insuliinin annostelua kuvaavat tilastolliset tunnuluvut.
                </li>
            <li>
              <b>Insuliinin jakautuminen:</b> Insuliinin jakautuminen basaali- ja bolusinsuliiniin sekä
                  vuorokauden aikana annostellut insuliinimäärät.
                </li>
            <li>
              <b>AGP-kuvaaja:</b> Kuvaaja on sama kuin AGP-raportissa.
                </li>
            <li>
              <b>Bolukset:</b> Bolusinsuliinin jakaantuminen vuorokauden aikana sekä tuntikohtaisten
                  bolusinsuliiniannosten vaihteluvälit.
                </li>
            <li>
              <b>Basaaliannostelu:</b> Insuliinipumpun käyttäjälle hyödyllinen näkymä, joka kuvaa
                  insuliinipumpun basaaliprofiilien vaihtelua vuorokauden aikana.
                </li>
          </ol>
        </p>
        <p>
          Insuliininäkymän alaosassa ovat 'Päivittäiset glukoosiprofiilit', joiden avulla tarkastelujaksosta
          pystyy muokkaamaan samalla tavoin kuin AGP-raportissa.
            </p>
        <p>
          <img src={introinsulin} alt="Insuliininäkymä" />
        </p>
      </section>
      <section id="nutrition">
        <h3>Ravinto</h3>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
      </section>
      <section id="exercise">
        <h3>Liikunta</h3>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
      </section>
      <section id="diary">
        <h3>Päiväkirja</h3>
        <p>
          <Link to="#top">Takaisin alkuun</Link>
        </p>
      </section> 
      */}
      <section id="day">
        <h2>Päivänäkymä</h2>
        <p>
          <Link to="#helpIntro">Takaisin alkuun</Link>
        </p>
        <p>
          Päivänäkymä koostuu seuraavista osista
        </p>
        <p>
          <ol>
            <li>
              <b>Glukoosikuvaaja:</b> Glukoosiarvojen mittaustulokset vuorokauden ajalta.
            </li>
            <li>
              <b>Muut tallennetut tiedot:</b> Insuliiniannokset ja arvioidut hiilihydraattimäärät.
            </li>
            <li>
              <b>Päivittäiset glukoosiprofiilit:</b> Profiilikuvaa klikkaamalla näytettävä päivä vaihtuu
                kyseiseen päivään.
            </li>
          </ol>
        </p>
        <p>
          Myös tässä näkymässä on mahdollista siirtyä päivästä toiseen “Päivittäiset glukoosiprofiilit”
          -otsikon (3) päivämääristä tai nuolinäppäimien avulla.
        </p>
        <p>
          <img src={introday} alt="Päivänäkymä" />
        </p>
      </section>
          <section id="penuser">
            <h2>Insuliinikynän käyttäjälle</h2>
            <p>
              <Link to="#helpIntro">Takaisin alkuun</Link> 
            </p>
            <p>
              Insuliinikynän käyttäjälle on tarjolla kaikki samat näkymät kuin insuliinipumpun käyttäjälle.
              Näkymissä on kuitenkin insuliinin annostelun osalta joitakin eroja. 
            </p>
            <p>
              Päivänäkymän kuvaajan alla esitetyt insuliiniannokset on esitetty insuliinikynän käyttäjälle 
              pitkä- ja lyhytvaikutteisena insuliinina. Pitkävaikutteisen insuliinin vaikutusajaksi on
              tässä esitystavassa laskettu 24 tuntia. Jos pitkävaikutteista insuliinia pistetään tätä useammin,
              muuttuu sininen palkki tummemman siniseksi niiltä osin kuin insuliiniannosten laskettu vaikutusaika
              osuu ajallisesti päällekkäin.
            </p>
            <p>
              <img src={introdaypenuser} alt="Päivänäkymä insuliinikynän käyttäjälle" />
            </p>
          </section>
      <footer>
        {/* The date is for MDR, annex I, clause 23.4, subclause y).
            Date format is specified in ISO 1041:2008 & A1:2013, clause 4.4.
        */}
        <small>2021-06-11</small>
      </footer>
    </main>
  );
}

export default HelpIntro;